import Image from "next/image"
import Link from "next/link"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "utils"
import { Location2Icon, ParkingIcon, PublicTransportIcon, WazeIcon } from "../icons"
import {
  AddressText,
  BusBadge,
  BusLines,
  DesktopCard,
  DesktopContentWrapper,
  DesktopHeaderRow,
  DesktopImageWrapper,
  DesktopTitleBlock,
  InfoBlock,
  InfoLabel,
  InfoRow,
  PortTitle,
  SecondaryText,
  TitleRow,
  WazeButton,
} from "./styled"
import { PortSlideCardProps } from "./types"

const PortSlideCardDesktop = ({
  port,
  direction,
  openInWazeLabel,
  publicTransportationLabel,
  parkingLabel,
  isActive,
}: PortSlideCardProps) => {
  const busLines = Array.from(
    new Set((port.busLines || []).map((line) => line.title).filter(Boolean)),
  )
  const hasParkingInfo = Boolean(port.parkingName || port.parkingAddress)
  const hasWazeLink = Boolean(port.wazeLink)

  return (
    <Link href={getNonUmbracoUrl(port.url) || "#"} style={{ textDecoration: "none" }}>
      <DesktopCard $direction={direction} $active={isActive}>
        <DesktopContentWrapper>
          <DesktopHeaderRow>
            <DesktopTitleBlock>
              <TitleRow>
                <Location2Icon />
                <PortTitle>{port.portName}</PortTitle>
              </TitleRow>
              {port.address && <AddressText>{port.address}</AddressText>}
            </DesktopTitleBlock>
            {hasWazeLink ? (
              <WazeButton
                href={getNonUmbracoUrl(port.wazeLink)}
                target="_blank"
                aria-label={`${openInWazeLabel} - ${port.portName}`}
                onClick={(e) => e.stopPropagation()}
              >
                <WazeIcon />
              </WazeButton>
            ) : (
              <WazeButton
                href="#"
                aria-label={`${openInWazeLabel} - ${port.portName}`}
                $isDisabled
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
              >
                <WazeIcon />
              </WazeButton>
            )}
          </DesktopHeaderRow>

          {busLines.length > 0 && (
            <InfoBlock>
              <InfoRow>
                <PublicTransportIcon />
                <InfoLabel>{publicTransportationLabel}</InfoLabel>
              </InfoRow>
              <BusLines>
                {busLines.map((line) => (
                  <BusBadge key={line}>{line}</BusBadge>
                ))}
              </BusLines>
            </InfoBlock>
          )}

          {hasParkingInfo && (
            <InfoBlock>
              <InfoRow>
                <ParkingIcon />
                <InfoLabel>{port.parkingName || parkingLabel}</InfoLabel>
              </InfoRow>
              {port.parkingAddress && <SecondaryText>{port.parkingAddress}</SecondaryText>}
            </InfoBlock>
          )}
        </DesktopContentWrapper>
        <DesktopImageWrapper>
          {port.mapDesktopImage && (
            <Image
              src={getUmbracoMediaUrl(port.mapDesktopImage)}
              alt={port.portName}
              priority
              fill
              style={{ objectFit: "cover" }}
            />
          )}
        </DesktopImageWrapper>
      </DesktopCard>
    </Link>
  )
}

export default PortSlideCardDesktop
